import { alias, list, object, primitive, serializable } from 'serializr';
import { CommodityMetaData } from './CommodityMeta.model';
import { Commodity } from './Commodity.model';

export class CommodityList {
  @serializable(list(object(Commodity)))
  commodities?: Commodity[];

  @serializable(alias('total_quantity', primitive()))
  totalQuantity?: number;

  @serializable(alias('total_revenue_percentage', primitive()))
  totalRevenuePercentage?: number;

  @serializable(object(CommodityMetaData))
  meta?: CommodityMetaData;
}
